/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!!  开发环境请不要不要不要直接修改 Config   !!!
 * !!!  如果需要修改请在最下方的安全编辑区域修改  !!!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

const Config = {
  HAS_HEADER: false,
  HTTP_URL: process.env.VUE_APP_API_HOST,
  HTTP_APPLY_URL: process.env.VUE_APP_APPLY_API_HOST,
  HTTP_URL2: process.env.VUE_APP_API_SW_HOST,
  TOLL_URL: process.env.VUE_APP_TOLL_HOST,
  BI_HTTP_URL: process.env.VUE_APP_BI_HOST,
  ZSBANK_CORPNO: process.env.VUE_APP_ZSBANK_CORPNO,
  ZSBANK_SECRETKEY: process.env.VUE_APP_ZSBANK_SECRETKEY,
  HTTP_TIMEOUT: 60000,
  VERSION: '3.2.5',
  COUNT_DOWN: 60,
  SYSTEM_INFO: {},
  // 生僻字姓名
  NAME_REG: /[\u2E80-\uFE4F]{2,15}(?:·[\u2E80-\uFE4F]{2,15})*/,
  // 姓名校验正则
  // NAME_REG: /[\u4E00-\u9FA5]{2,15}(?:·[\u4E00-\u9FA5]{2,15})*/,
  // 车牌号校验正则
  CAR_PLATE_REG: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})$/,
  // 中文校验正则
  CHINESE_REG: /^[\u4e00-\u9fa5]+$/,
  // 中文生僻字
  UNCOMMON_CHINESE_REG: /^[\u2E80-\uFE4F]$/,
  // 收货地址正则 至少得有汉字
  ADDRESS_REG: /^([ \S]*[\u4E00-\u9FFF]+[ \S]*)*$/,
  // 手机号正则
  PHONE_REG: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
  // 身份证正则
  ID: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  FILTER_ADDRESS_REG: /([^ \-\da-zA-Z\u4e00-\u9fa5])/g
}

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!!  安全区域 !!!!!!!!!!!!!!!!!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

export default Config
